// extracted by mini-css-extract-plugin
module.exports = {"updateRow":"_63abdd9","updateCol":"_83b0180","header":"bdf97f7","managementUpdate":"bd9267f"};